module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1e852f8aa425e90a92236f2268591f80.png";